import axios from "axios";
import Config from "../utils/Config";

class AgentsService {
  getAuthHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      },
    };
  }
  async getAgents() {
    try {
      const response = await axios.get(
        `${Config.API_BASE_URL}/admin/all/agents`,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data?.data?.reason || "Agents fetched successfully",
        data: response.data?.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while getting agents",
        data: null,
      };
    }
  }

  async agentStatusChange(agent_slug, payload, status){
    try{
      const response = await axios.post(
        `${Config.API_BASE_URL}/admin/${status}/agent/${agent_slug}`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status:true,
        data:response.data,
        message:response.data?.data?.reason || "Agent activated successfully"
      }
    }catch(error){
      return {
        status:false,
        data:null,
        message:error?.response?.data?.data?.reason || "An error occurred while activating agent"
      }
    }
  }

  async removeAgentAccount(agent_slug){
    try{
      const response = await axios.post(
        `${Config.API_BASE_URL}/admin/remove/agent/${agent_slug}`,
        {},
        this.getAuthHeaders()
      );
      return {
        status:true,
        data:response.data,
        message:response.data?.data?.reason || "Agent account removed successfully"
      }
    }catch(error){
      return {
        status:false,
        data:null,
        message:error?.response?.data?.data?.reason || "An error occurred while removing agent account"
      }
    }
  }
}

const agentsService = new AgentsService();
export default agentsService;
